export default function () {
  return {
    historico: {
      data: [],
      links: {},
      meta: {},
    },
  };
}
